import { formatDateString } from "./formatDateString";

export function formatTime(
    date: Date,
    { milliseconds }: { milliseconds: boolean } = {
        milliseconds: true,
    },
): string {
    return formatDateString(
        date,
        `h:mm:ss${milliseconds ? ".SSS" : ""} a`,
    ).toLocaleLowerCase();
}
